import { type ColumnInfo, type RowInfo } from './types'

// セル内の改行を1つの空白に潰す。TSV では改行が行区切りなので、セルに残すとそこで行が
// 物理的に割れ、以降のタブ位置と列の対応が崩れる。9segs 表頭の `積極\n認知未購入`
// `ユーザー内\n消極` や 5segs 表頭の `ロイヤル\nvs\n認知未購入` (nineSegments.ts /
// fiveSegments.ts の i18n ラベル。画面では2〜3行で見せたいので改行はラベル側に必要)が
// 該当し、潰さないと AI コメントの入力データで列を位置から特定できず、
// クリップボード経由の Excel 貼り付けも1セルに収まらない。
const toSingleLine = (text: string): string => text.replace(/\s*\n\s*/g, ' ')

/**
 * テーブル情報をタブ区切り、改行区切りのテキストに変換します。
 * すべてのセルが空である行は、出力テキストから除外されます。
 * セル内の改行は空白に潰されます。
 *
 * @template K - 列キーの型。
 * @param columns - 列情報の配列。
 * @param tableInfo - 行情報の配列。
 * @returns タブ区切りのセル、改行区切りの行で構成されたテキスト。
 */
export function serializeTableToText<K extends string>(
  columns: ColumnInfo<K>[],
  tableInfo: RowInfo<K>[],
): string {
  const lines: string[] = []
  for (const row of tableInfo) {
    const cells: string[] = []
    let hasContent = false
    for (const col of columns) {
      const cell = row[col.key]
      const text =
        cell?.text !== undefined ? toSingleLine(String(cell.text)) : ''
      cells.push(text)
      if (text !== '') {
        hasContent = true
      }
    }
    if (hasContent) {
      lines.push(cells.join('\t'))
    }
  }

  return lines.join('\n')
}
